"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _useListState2 = _interopRequireDefault(require("../../hooks/useListState.hook"));
var _useOverlapState2 = _interopRequireDefault(require("../../hooks/useOverlapState.hook"));
var _Text = _interopRequireDefault(require("../Text"));
var _CloseIcon = _interopRequireDefault(require("../CloseIcon"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _BurgetIcon = _interopRequireDefault(require("../BurgetIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var size = 5;
var Header = function Header(props) {
  var type = props.type;
  var _useOverlapState = (0, _useOverlapState2["default"])(),
    toggle = _useOverlapState.toggle;
  var _useListState = (0, _useListState2["default"])(),
    listToggle = _useListState.toggle;
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: theme.size(size),
      backgroundColor: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low, 0.05)
    };
  });
  var titleClass = (0, _useCss["default"])(function (theme) {
    return {
      marginLeft: theme.size(2),
      color: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.high, 0.75)
    };
  });
  var toggleClass = (0, _useCss["default"])(function (theme) {
    return _defineProperty({}, theme.screen.up('mobile'), {
      display: 'none'
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: rootClass,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      width: 8,
      height: 5,
      onClick: listToggle,
      className: toggleClass,
      disabled: type !== 'components',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgetIcon["default"], {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
      weight: "black",
      size: "large",
      className: titleClass,
      children: "React Dev Tabs"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      width: 8,
      height: 5,
      onClick: toggle,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseIcon["default"], {})
    })]
  });
};
var _default = Header;
exports["default"] = _default;